 <div class="modal-popup" *ngIf="popObject">
  <div class="popup-container">
    <div class="inner-container">
      <p class="title">{{popObject.title}}</p>
      <p class="description">
        {{popObject.description}}
      </p>
      <div class="btns-container">
        <div *ngFor="let btn of popObject.buttons; let i = index">
          <div [ngSwitch]="btn.btnType" [ngClass]="{'mr-r-12': i === 0}">
            <lib-button-secondary *ngSwitchCase="2" id="popup-btn-2" (click)="btn.func() ; clearState()">
              {{btn.title}}
            </lib-button-secondary>
  
            <lib-button-tertiary *ngSwitchCase="3" id="popup-btn-3" (click)="btn.func() ; clearState()">
              {{btn.title}}
            </lib-button-tertiary>
  
            <lib-button-primary *ngSwitchDefault id="popup-btn-1" (click)="btn.func() ; clearState()">
              <p>
                {{btn.title}}
              </p>
            </lib-button-primary>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
